import React from 'react';
import { HashLink } from 'react-router-hash-link';

const NavLinks = ({ isScrolled = false }) => {
    /* `isScrolled` is `!top` from NavBar — true after the user scrolls past the
       hero (white nav bg), false while the navbar is overlaid on the hero video
       (translucent dark backdrop). Links need to be white in the latter case so
       they read against the video. */
    const linkStyles = {
        default: `px-4 font-extrabold transition-colors duration-300 ${isScrolled ? 'text-gray-800' : 'text-white'}`,
        hover: isScrolled ? "hover:text-[#5b2a2a]" : "hover:text-white/80",
        animated: "relative group"
    };

    return (
        <>
            <HashLink
                className={`${linkStyles.default} ${linkStyles.hover}`}
                smooth to="/#about"
            >
                About
            </HashLink>
            <HashLink
                className={`${linkStyles.default} ${linkStyles.hover}`}
                smooth to="/#services"
            >
                Services
            </HashLink>
            <HashLink
                className={`${linkStyles.default} ${linkStyles.animated}`}
                to="/products"
            >
                Products
                <span className="absolute inset-0 rounded-lg border-2 border-transparent animate-border"></span>
            </HashLink>
            <HashLink
                className={`${linkStyles.default} ${linkStyles.hover}`}
                to="/contact#contact"
            >
                Contact Us
            </HashLink>
            <HashLink
                className={`${linkStyles.default} ${linkStyles.hover}`}
                to="/license"
            >
                License
            </HashLink>
            <HashLink
                className="text-white bg-[#5b2a2a] hover:bg-[#4e2323] inline-flex items-center justify-center w-auto px-6 py-3 shadow-xl rounded-xl transition-colors duration-300"
                smooth to="/get-demo#demo"
            >
                Demo our products
            </HashLink>

            <style jsx>{`
                .animate-border {
                    border-color: #5b2a2a;
                    animation: pulse 1.5s infinite;
                    border-radius: 0.5rem;
                }

                @keyframes pulse {
                    0%, 100% {
                        border-color: transparent;
                    }
                    50% {
                        border-color: #5b2a2a;
                    }
                }
            `}</style>
        </>
    );
};

export default NavLinks;
